<div class="sensor-detail-body row" id="sensor-detail-stream">
  <div class="col-md-12">
    <div class="page-title">Parameters</div>
  </div>
  <div class="col-md-12">
    <table class="table table-responsive-md parameters" id="parameters-status">
      <tbody>
      <tr class="parameters-line" *ngFor="let property of this.getParam(this.streamNotificationService.getFeature())">
        <td>{{ property.name }}</td>
        <td>{{ property.description }}</td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="col-md-12">
    <div class="page-title">Activity Log</div>
  </div>
  <div style="width: 100%" class="row row-top-margin row-0-margin" id="row-sensors-log-table">
    <app-search-bar
      [placeholderTitle]="searchbarPlaceholderTitle" [data]="sensorLogs"
      [searchTerm]="searchTerm" [searchProperties]="searchOption"
      [page]="paginationProperties.getPage()" [step]="paginationProperties.getStep()"
      (updateDisplayData)="updateDisplayDataEventEmitter($event)"></app-search-bar>
    <app-table
      [tableRowObjects]="paginationProperties.getDisplayedData()"
      [tableAttributes]="tableProperties"
      id="sensors-log-table"
      style="width: 100%">
    </app-table>
    <app-pagination style="width: 100%"
                    [steps]="paginationProperties.getSteps()" [pages]="paginationProperties.getPages()"
                    [step]="paginationProperties.getStep()" [page]="paginationProperties.getPage()"
                    [maxPage]="paginationProperties.getMaxPage()"
                    [isPreviousButtonDisabled]="paginationProperties.getIsPreviousButtonDisabled()"
                    [isNextButtonDisabled]="paginationProperties.getIsNextButtonDisabled()"
                    [filteredData]="paginationProperties.getFilteredData()" [displayedData]="paginationProperties.getDisplayedData()"
                    (updateStep)="updateStep($event)"
                    (clickPreviousButton)="clickPreviousButton($event)"
                    (clickNextButton)="clickNextButton($event)"></app-pagination>
  </div>
</div>
